// Others
import { urlApiTask } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IFormTask,
  IQueryChangeStatusTask,
  IQueryUpdateTask,
  ITask,
  ITaskDetail,
} from '~/utils/interface/task';
import { IQueryParamBase } from '~/utils/interface/common';
import { IQueryCreateTaskJob, IQueryEditTaskJob } from '~/utils/interface/job';

const taskApi = {
  getTaskList: (params: IQueryParamBase) => {
    const url = urlApiTask.getTaskList;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITask[]>>>(url, { params });
  },

  createTask: (body: IFormTask) => {
    const url = urlApiTask.createTask;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  deleteTask: (taskId: string) => {
    const url = urlApiTask.deleteTask(taskId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  getTaskDetail: (taskId: string) => {
    const url = urlApiTask.getTaskDetail(taskId);
    return axiosClient.get<IBaseResponse<ITaskDetail>>(url);
  },

  updateTask: ({ taskId, body }: IQueryUpdateTask) => {
    const url = urlApiTask.updateTask(taskId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  changeStatusTask: ({ taskId, body }: IQueryChangeStatusTask) => {
    const url = urlApiTask.changeStatusTask(taskId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  createTaskJob({ jobId, body }: IQueryCreateTaskJob) {
    const url = urlApiTask.createTaskJob(jobId);
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateJobTask: ({ taskId, body }: IQueryEditTaskJob) => {
    const url = urlApiTask.updateTask(taskId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default taskApi;
